import { Injectable } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Dictionary } from '@core/models/dictionary';
import { catchError, map, retry } from 'rxjs/operators';
import { environment } from '@env/environment';
import { FeatureFlagOptions } from '@core/models/featureFlagOptions';
import { of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class FeatureFlagService {
	public apiFeatureUrl: string;
	public headers: HttpHeaders;
	public options: any;
	public filters: any;
	private token: string;

	constructor(private httpClient: HttpClient) {

		if (environment.name == 'mock') {
			this.apiFeatureUrl = 'https://pm-d-suite-apim.azure-api.net/pv/feature-flag/{FeatureName}/{Residence}?subscription-key=ed11c66b99284a1c833ceabf06a941a8';
			//this.apiFeatureUrl = 'https://webhook.site/f70b5860-4d02-40eb-87cb-329e7a25c5fb/{FeatureName}/{Residence}';
		} else {
			this.apiFeatureUrl = 'https://pm-p-suite-apim.azure-api.net/pv/feature-flag/{FeatureName}/{Residence}?subscription-key=f344cd0f76cd4260aaf625ca613e731f';
		}
	}

	public async getIntakeFeature() : Promise<FeatureFlagOptions> {

		this.options = {
			headers: this.headers,
			responseType: "json"
		};

		let config = JSON.parse(localStorage.getItem('config'));

		if (config && config.residence) {
			
			var url = this.apiFeatureUrl.replace('{Residence}', config.residence.code);
			url = url.replace('{FeatureName}', "intake-redirect");

			return this.httpClient.get(url, this.options)
			.pipe(
				map(
                (res) => {
					return Object.assign(new FeatureFlagOptions(), res);
                }
            ), catchError((error) => {
				console.log(error);
				return of(new FeatureFlagOptions()); 
			})).toPromise();
		}

		return Promise.resolve(new FeatureFlagOptions());	
	}
}
